function groupByFlag(filteredData, flag) {
    const flagMappings = {
        'llm': { nameField: 'llm_name', idField: 'llm_id' },
        'market': { nameField: 'market_name', idField: 'market_id' },
        'geography': { nameField: 'geography_name', idField: 'geography_id' },
        'persona': { nameField: 'persona_name', idField: 'persona_id' },
        'category': { nameField: 'category_name', idField: 'category_id' }
    };

    if (!flagMappings[flag]) {
        throw new Error(`Invalid flag: ${flag}. Valid flags are: ${Object.keys(flagMappings).join(', ')}`);
    }

    const { nameField } = flagMappings[flag];
    const result = {};
    const processedSources = new Set(); // Track processed source_ids to avoid double counting

    // Group by the specified flag name
    filteredData.forEach(item => {
        const groupName = item[nameField];
        const domainUrl = item.domain_url;
        const sourceKey = `${groupName}-${domainUrl}-${item.source_id}`;

        // Initialize group if it doesn't exist
        if (!result[groupName]) {
            result[groupName] = {};
        }

        // Initialize domain if it doesn't exist
        if (!result[groupName][domainUrl]) {
            result[groupName][domainUrl] = {
                source_alias_count: 0,
                aliases: []
            };
        }

        // Add count_sources only once per unique source_id within the same group and domain
        if (!processedSources.has(sourceKey)) {
            result[groupName][domainUrl].source_alias_count += item?.count_sources || item?.cnt_source_id || 0;
            processedSources.add(sourceKey);
        }

        // Add alias information (this should be added for each alias)
        result[groupName][domainUrl].aliases.push({
            source_alias_id: item.source_alias_id,
            source_alias_url: item.source_alias_url,
            http_status: item.http_status,
            alias_signal_strength: item.alias_signal_strength,
            alias_absolute_count: item.alias_absolute_count,
            alias_query_count: item.alias_query_count,
            is_positive: item.is_positive,
        });
    });

    return result;
}

export function transformSourceData(data, flag) {
    if (!data || data.length === 0) return {};
    const mostRecentDate = findMostRecentDate(data);
    const filteredData = data.filter(item =>
        item.year === mostRecentDate.year &&
        item.month === mostRecentDate.month &&
        item.day === mostRecentDate.day
    );
    return groupByFlag(filteredData, flag);
}

function findMostRecentDate(data) {
    const uniqueDates = [...new Set(data.map(item =>
        `${item.year}-${String(item.month).padStart(2, '0')}-${String(item.day).padStart(2, '0')}`
    ))];
    const mostRecent = uniqueDates.sort((a, b) => new Date(b) - new Date(a))[0];
    const [year, month, day] = mostRecent.split('-').map(Number);
    return { year, month, day };
}

export function normalizeData(data, llm) {
    if (!data || data.length === 0) return [];
    return data.map(item => {
        const updatedItem = { ...item };

        Object.keys(item || {}).forEach(key => {
            if (typeof item[key] === "object" && item[key].aliases) {
                // ✅ If key is 'gpt-5-search-enabled', set http_status = '200' for all aliases
                const aliasesWithStatus = item[key].aliases.map(alias => {
                    if (key === "gpt-5-search-enabled" || llm === "gpt-5-search-enabled") {
                        return { ...alias, http_status: "200" };
                    }
                    return alias;
                });

                const merged = {};

                aliasesWithStatus.forEach(alias => {
                    const uniqueKey = `${alias.source_alias_id}-${alias.source_alias_url}`;
                    if (!merged[uniqueKey]) {
                        merged[uniqueKey] = { ...alias };
                        merged[uniqueKey].alias_absolute_count = Number(alias.alias_absolute_count || 0);
                    } else {
                        merged[uniqueKey].alias_absolute_count += Number(alias.alias_absolute_count || 0);
                    }
                });

                const aliases = Object.values(merged);

                const aliasTotalCount = aliases.reduce(
                    (sum, alias) => sum + Number(alias.alias_absolute_count || 0),
                    0
                );

                updatedItem[key] = {
                    ...item[key],
                    aliases,
                    aliasTotalCount
                };
            }
        });

        return updatedItem;
    });
}

export function formatSourceData(sources, llm) {
  const response = {
    [llm]: {}
  };

  const CONSTANTS = {
    alias_signal_strength: "7",
    alias_query_count: 1,
    is_positive: 0
  };

  // 🔹 Normalize sources
  let normalizedSources = [];

  if (Array.isArray(sources)) {
    normalizedSources = sources;
  } else if (sources && typeof sources === "object") {
    // convert object map → array
    normalizedSources = Object.entries(sources).map(([url, count]) => ({
      url,
      count
    }));
  }

  normalizedSources.forEach((item, index) => {
    if (!item?.url) return;

    try {
      const hostname = new URL(item.url).hostname;

      if (!response[llm][hostname]) {
        response[llm][hostname] = {
          source_alias_count: 0,
          aliases: []
        };
      }

      const aliasObj = {
        source_alias_id: 10000 + index,
        source_alias_url: item.url,
        http_status: String(item.http_status ?? "200"),
        alias_signal_strength: CONSTANTS.alias_signal_strength,
        alias_absolute_count: item.count ?? 1,
        alias_query_count: CONSTANTS.alias_query_count,
        is_positive: CONSTANTS.is_positive
      };

      response[llm][hostname].aliases.push(aliasObj);
      response[llm][hostname].source_alias_count += aliasObj.alias_absolute_count;

    } catch (err) {
      console.error("Invalid URL in source item:", item);
    }
  });

  return response;
}


export function formatOldSourceData(sources, llm) {
  console.log("sourcesRecordssssss",sources)
  const response = {};
  // initialize top-level object for llm
  response[llm] = {};
  sources.forEach((url, index) => {
    try {
      const hostname = new URL(url).hostname;
      // if this hostname doesn't exist, create it
      if (!response[llm][hostname]) {
        response[llm][hostname] = {
          source_alias_count: 0,
          aliases: []
        };
      }
      // create alias object (constants + dynamic URL)
      const aliasObj = {
        source_alias_id: 10000 + index, // dynamic id
        source_alias_url: url,
        http_status: "200",
        alias_signal_strength: "7",
        alias_absolute_count: 1,
        alias_query_count: 1,
        is_positive: 0
      };
      // push alias and increment count
      response[llm][hostname].aliases.push(aliasObj);
      response[llm][hostname].source_alias_count += aliasObj.alias_absolute_count;
    } catch (e) {
      console.error("Invalid URL:", url);
    }
  });
  return response;
}


